// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"3d669ad1","139":"6e8a2165","173":"0936e4bd","510":"6baddf52","573":"4fbd6afa","995":"f1f5d4a4"}[chunkId] + ".chunk.js";
};